/**
 * The expanded ingest session. This job page is the only full-size home for a
 * run — chat surfaces link out to it rather than hosting the session inline.
 */
export const INGEST_QUESTION_PARAM = 'question'

export function ingestFullSessionPath(
  jobId: string,
  opts?: { questionId?: string | null }
): string {
  const path = `/ingest/jobs/${encodeURIComponent(jobId)}/agent`
  const questionId = opts?.questionId?.trim()
  if (!questionId) return path
  const params = new URLSearchParams({ [INGEST_QUESTION_PARAM]: questionId })
  return `${path}?${params.toString()}`
}

export function ingestQuestionElementId(writeId: string): string {
  return `ingest-question-${writeId}`
}

export const INGEST_SESSION_FOCUS_STATE = { focusCurrentIngest: true as const }
